import $ from 'jquery';

export const init = ($target) => {
	const $kwh = $('.js-inp-kwh'),
		$mwh = $('.js-inp-mwh'),
		$btn = $('.js-recalculation-btn');

	function recalculate(params) {
		let ratio = $btn.attr('data-ratio');
		let kwhVal = $kwh.val().replace(/,/g, '.'),
			mwhVal = $mwh.val().replace(/,/g, '.');
		if (kwhVal !== '') {
			$mwh.val(Math.round((kwhVal * 100) / ratio) / 100);
		} else {
			if (mwhVal !== '') {
				$kwh.val(Math.round(mwhVal * ratio * 100) / 100);
			}
		}
	}
	$btn.on('click', recalculate);
};
